document.addEventListener("turbolinks:load", function (e) {
    if ($('#seminar_applicants').length > 0) {
        $('select[name="admin_seminar_applicant_search_form[seminar_id_eq]"]').change(function() {
            ajax_seminar_schedules($(this).val());
        })
        $('input[name="admin_seminar_applicant_search_form[seminar_id_eq]"]').change(function() {
            ajax_seminar_schedules($(this).val());
        })
        const ajax_seminar_schedules = function(seminar_id) {
            if (seminar_id.length === 0) seminar_id = -1;
            $.ajax({
                type: 'GET',
                url: `/admin/seminars/${seminar_id}/seminar_schedules`,
                dataType: 'script'
            })
        };
    }
});